<textarea  class="setWidth100 noExit" rows="{{rowCount}}" [ngModel]="appStateService.currentClient.Notes" (ngModelChange)="notesChanged.next($event)"></textarea>
<div class="absolute">
	<span *ngIf="savingNotes" class="relative green-text">
		<em>Saving notes...</em>
		<portal-spinner class="absolute top10 rightneg8" [height]="'htpx18'" [width]="'wdthpx18'"></portal-spinner>
	</span>
</div>